import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';

class PrivacyPolicy extends Component {
    render() {
        return (
            <div className="site-wrap">
                <Header page={'privacyPolicy'} />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><strong className="text-black">Privacy Policy</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className='textpara col-md-12'>
                            <strong>Effective Date: 01/01/2025</strong> <br />
                                At Pelican Edu Supply, we value the privacy and security of your personal information. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our online supply platform for school materials, including books, uniforms, notebooks, stationery, and other related products. By using our website, you agree to the collection and use of information in accordance with this policy.
                                <br /> <br />
                                <h4>1. Information We Collect</h4>
                                
                                We collect personal information to provide our services and improve your shopping experience. The types of information we may collect include:
                                <br />
                                <strong>Personal Information:</strong>
                                <ul>
                                    <li>Name</li>
                                    <li>Email address</li>
                                    <li>Phone number</li>
                                    <li>Shipping address</li>
                                    <li>Billing address</li>
                                    <li>Payment information (processed securely through third-party payment processors)</li>
                                </ul>
                                {/* Usage Data:
                                IP address
                                Browser type and version
                                Pages visited on the website
                                Time and date of your visit
                                Time spent on those pages
                                Other diagnostic data
                                Cookies and Tracking Technologies: We use cookies to enhance user experience, track usage patterns, and analyse traffic. You can control cookies through your browser settings. */}
                                <h4>2. How We Use Your Information</h4>
                                We use your personal data for the following purposes:
                                <br />
                                <ul>
                                    <li><strong>To Process Orders:</strong> To fulfil your orders for school materials such as books, uniforms, and other supplies.</li>
                                    <li><strong>To Communicate with You:</strong> To send order confirmations, shipping updates, customer support, and marketing communications (with your consent).</li>
                                    <li><strong>To Process Payments:</strong> Payment information is securely handled by third-party payment processors.</li>
                                    <li><strong>To Ensure Security:</strong> To monitor and protect the integrity of our website and prevent fraud.</li>
                                </ul>
                                {/* To Improve Our Services: To analyse trends, track website usage, and gather feedback for improving the customer experience. */}
                                
                                <h4>3. How We Share Your Information</h4>
                                We do not sell, rent, or share your personal information with third parties except for the following:
                                <br />
                                <ul>
                                    <li><strong>Third-Party Service Providers:</strong> We may share your information with trusted vendors who help us with payment processing, order fulfilment, shipping, and other essential services. These providers are obligated to safeguard your information and only use it for the purposes we have authorized.</li>
                                    <li><strong>Legal Compliance:</strong> We may disclose your information if required by law or in response to legal processes, such as a subpoena or court order.</li>
                                </ul>
                                
                                <h4>4. Data Security</h4>
                                We take the security of your personal information seriously. We use industry-standard security protocols to protect your data during transmission and storage. However, no method of data transmission over the internet is completely secure. While we strive to protect your personal data, we cannot guarantee its absolute security.
                                <br />  <br />

                                <h4>5. Retention of Data</h4>
                                We retain your personal information only for as long as necessary to fulfil the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law.
                                <br />  <br />

                                <h4>6. Your Rights</h4>
                                
                                You have the right to:
                                <br />
                                <ul>
                                    <li><strong>Access:</strong> Request access to the personal information we hold about you.</li>
                                    <li><strong>Rectification:</strong> Request corrections to any inaccurate or incomplete information.</li>
                                    <li><strong>Deletion:</strong> Request the deletion of your personal information, subject to applicable legal requirements.</li>
                                    <li><strong>Opt-Out:</strong> You can unsubscribe from marketing communications at any time by following the "unsubscribe" link in emails or by contacting us directly.</li>
                                </ul>
                                
                                <h4>7. Children's Privacy</h4>
                                Our website is not intended for children under the age of 13, and we do not knowingly collect or maintain personal information from children under this age. If you believe we have collected personal information from a child under 13, please contact us immediately, and we will take steps to delete such information.
                                <br />  <br />
                                <h4>8. Changes to This Privacy Policy</h4>
                                We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the "Effective Date" will be updated accordingly. We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.
                                <br />  <br />
                                <h4>9. Contact Us</h4>
                                If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:
                                <br/>
                                PelicanEduSupply <br/>
                                C/o Pelican publishing house <br/>
                                plot no2/b, C. F area, I.D.A cherlapally, Hyderabad 500050. <br/>
                                Email: pelicanpublishinghouse@gmail.com
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default PrivacyPolicy;